<template>
  <div class="con">
    <div class="container">
      <h2 class="text-center">كورسات الفصول الدراسية</h2>
      <div
        class="phases d-flex justify-content-xl-between justify-content-center align-items-center flex-lg-row flex-column gap-lg-3 gap-5"
      >
        <!-- <router-link
          class="card-phase-1"
          :to="{ name: 'courseList', params: { phase: 'phase-1' } }"
        >
          <div class="header">
            <img
              src="../../assets/phases.jpg"
              alt="الأول الثانوي"
              class="w-100 h-100 card-img"
            />
            <span class="num">1</span>
          </div>
          <h3 class="text-center">الأول الثانوي</h3>
        </router-link>
      <router-link
          class="card-phase-1"
          :to="{ name: 'courseList', params: { phase: 'phase-2' } }"
        >
          <div class="header">
            <img
              src="../../assets/phases.jpg"
              alt="الثاني الثانوي"
              class="w-100 h-100 card-img"
            />
            <span class="num">2</span>
          </div>
          <h3 class="text-center">الثاني الثانوي</h3>
        </router-link>
      <router-link
          class="card-phase-1"
          :to="{ name: 'courseList', params: { phase: 'phase-3' } }"
        >
          <div class="header">
            <img
              src="../../assets/phases.jpg"
              alt="الثالث الثانوي"
              class="w-100 h-100 card-img"
            />
            <span class="num">3</span>
          </div>
          <h3 class="text-center">الثالث الثانوي</h3>
        </router-link> -->
        <router-link
          class="card-phase"
          :to="{ name: 'courseList', params: { phase: 1 } }"
        >
          <img
            src="../../assets/phase-1.png"
            alt="الأول الثانوي"
            class="w-100 h-100 card-img"
          />
        </router-link>
        <router-link
          class="card-phase"
          :to="{ name: 'courseList', params: { phase: 2 } }"
        >
          <img
            src="../../assets/phase-2.png"
            alt="الثاني الثانوي"
            class="w-100 h-100 card-img"
          />
        </router-link>
        <router-link
          class="card-phase"
          :to="{ name: 'courseList', params: { phase: 3 } }"
        >
          <img
            src="../../assets/phase-3.png"
            alt="الثالث الثانوي"
            class="w-100 h-100 card-img"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhasesComponent",
};
</script>

<style scoped>
/* .card-phase-1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  width: calc(100% / 3 - 1rem);
  scale: 1;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  color: #dad2c5;
  text-decoration: none;
}
.card-phase-1:hover {
  scale: 1.05;
}
.card-phase-1 .header {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 0;
}
.card-phase-1 .header img {
  width: 94% !important;
  height: 100%;
  object-fit: cover;
  border-radius: 1.25rem;
}
.card-phase-1 .header .num {
  width: 20%;
  position: absolute;
  bottom: -19%;
  right: 0;
  transform: translate(-80%, 0);
  font-size: 20rem;
  font-weight: 500;
  color: transparent;
  -webkit-text-stroke: 2px #dad2c5;
  pointer-events: none;
  z-index: 5;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
} */

/* ================= */
.con {
  min-height: 100vh;
  padding: 5em 0;
}
body.dark .con h2 {
  color: #dad2c5;
}
.con h2 {
  color: #1e1e1e;
  font-size: 2.25rem;
  font-weight: 500;
}
.phases {
  padding: 3rem 0;
}
.card-phase {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 3 - 1rem);
  scale: 1;
  transition: all 0.3s ease-in-out;
}
.card-phase:hover {
  scale: 1.05;
}
.card-phase img {
  max-width: 90%;
}
@media (max-width: 1200px) {
  .card-phase img {
    max-width: 100%;
  }
}
@media (max-width: 992px) {
  .card-phase {
    width: calc(100% / 2 - 1rem);
  }
}
@media (max-width: 768px) {
  .card-phase {
    width: 100%;
  }
}
</style>
